import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errMsg } from "@/lib/api";
import { EventPicker, applyEvent } from "./EventPicker";

// Multi-select: "Set event" for many photos (only the user's own, or any for an admin)
export const EventDialog = ({ ids, onClose, onDone }) => {
  if (!ids) return null;
  const pick = async (category, event, person) => {
    try {
      const r = await applyEvent(ids, category, event, person);
      toast.success(`Event set on ${r.done} photo${r.done === 1 ? "" : "s"}${r.skipped ? ` · ${r.skipped} owned by others skipped` : ""}`);
      onDone();
      onClose();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm bg-[#f4f3f0]" data-testid="event-dialog">
        <DialogHeader>
          <DialogTitle className="serif text-2xl">Set event</DialogTitle>
          <DialogDescription>{ids.length} photo{ids.length === 1 ? "" : "s"} selected</DialogDescription>
        </DialogHeader>
        <div className="max-h-[60vh] overflow-y-auto"><EventPicker onPick={pick} testid="bulk-event" /></div>
      </DialogContent>
    </Dialog>
  );
};
